import { Backdrop, Badge } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Styles from './VideoPopup.module.scss';
import { useContext } from 'react';
import { ViewContext } from 'components/lib';

export const VideoPopup = ({ showInfo, hideChallengeInfo, videoSrc }) => {
	const handleVideoClose = () => {
		const videoElement = document.getElementById('videoPlayer');
		if (videoElement) {
			videoElement.pause(); // Pause the video
			videoElement.currentTime = 0; // Reset the video to the beginning
		}
		hideChallengeInfo();
	};
	const viewContext = useContext(ViewContext);
	return (
		<Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={showInfo}>
			<Badge
				aria-label={viewContext.t("Components.VideoPopup.label")}
				badgeContent={
					<CloseIcon
						className={Styles.closeBadge}
						onClick={handleVideoClose}
						style={{
							height: '40px',
							width: '40px',
						}}
					/>
				}
				anchorOrigin={{
					vertical: 'top',
					horizontal: 'right',
				}}
			>
				<div id="challengeInfoContainer" className={Styles.challengeInfoCard}>
					<div id="videoContainer" className={Styles.videoContainer}>
						<video
							id="videoPlayer"
							disablePictureInPicture
							autoPlay
							muted
							controls
							className={Styles.videoPlayer}
							controlsList="nodownload"
						>
							<source src={videoSrc} type="video/mp4" />
							{viewContext.t("Components.VideoPopup.warning")}
						</video>
					</div>
				</div>
			</Badge>
		</Backdrop>
	);
};
